
<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="topSearch">
      <form action="/">
        <van-search v-model="serKey" placeholder="请输入搜索关键词" @search="onSearch" />
      </form>
    </div>
    <div class="historySearch">
      <van-row class="barLine">
        <van-col span="12">搜索历史</van-col>
        <van-col span="12" class="rigth" />
      </van-row>
      <van-tag v-for="(item,index) in searchLogList" :key="index" round size="large" color="#ddd" text-color="#000"><span @click="onTagClick(item)">{{ item }}</span></van-tag>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Search, Tag } from 'vant'
import TopBar from '@/components/TopBar'
import { GetSysTitle } from '@/utils/base'
export default {
  components: {
    [Search.name]: Search,
    [Tag.name]: Tag,
    TopBar
  },
  data() {
    return {
      titleTop: GetSysTitle(),
      serKey: '',
      title: '我的订单',
      backurl: '/my/index',
      searchLogList: []
    }
  },

  created() {
    this.init()
  },
  methods: {
    init() {
      request({
        url: '/StoreHelper/getStoreCommentSearchLog',
        method: 'post'
      }).then(response => {
        this.searchLogList = []
        if (!response.success) {
          return
        }
        this.searchLogList = response.data
      })
    },
    onSearch() {
      this.$router.push('/store/list?key=' + this.serKey)
    },
    onTagClick(key) {
      this.$router.push('/store/list?key=' + key)
    }
  }
}
</script>
<style scoped>
.topSearch{
    border-bottom: 1px solid #ddd;
}
.historySearch{
    padding: 0.5em;
}
.historySearch span{
    padding:0.4em 0.5em;
}
.van-tag{
    margin: 0.3em;
}
.barLine{
    line-height: 2.2em;
}
</style>
